package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetSessionsResponse(
    val data: List<GetSessionsData>
)
@Serializable
data class GetSessionsResponseSingle(
    val data: GetSessionsData
)
@Serializable
data class GetSessionsData(
    val id: String = "",
    val rev: String = "",
    val audioPath: String = "",
    val coachName: String = "",
    val domainType: String = "",
    val language: String = "",
    val organization: String = "",
    val category : String? = null,
    val recordTime: String = "",
    val sessionDateTime: String = "",
    @SerialName("sessionID")
    val sessionId: String = "",
    val sessionType: String = "",
    val keywords: List<GetSessionKeyword> = emptyList(),
    val sementics: GetSessionSementics = GetSessionSementics(),
    val status: String = "",
    val statusUrl: String = "",
    val role: String = "",
    val keyInsights: String = "",
    val type: String = "",
    val rating: Double = 0.0,
    @SerialName("userID")
    val userId: String = "",
    @SerialName("playerID")
    val playerId: String = "",
    var videoFile: String = "",
    val playerName: String = "",
    val tagPlayers: List<String>?=emptyList(),
    val tagCoaches: List<String>?=emptyList(),
    var sessionData: String = "",
    val speakingTime: Double = 0.0,
    val summary: String = "",
    var summaryRevision: Int = 0,
    val text: String = "",
    val totalKeywords: Int = 0,
    val wordCount: Int = 0,
    val emphasis: String = "",
    @SerialName("widgetMetrics")
    val widgetMetrics: SessionWidgetMetrics? = null,
)


@Serializable
data class SessionDataDetailsResponse(
    val response: SessionDataDetailsData,
)
@Serializable
data class SessionDataDetailsData(
    @SerialName("emotion analysis")
    val emotionAnalysis: EmotionAnalysis,
    @SerialName("keys number")
    val keysNumber: Long,
    @SerialName("keyword extraction")
    val keywordExtraction: KeywordExtraction,
    @SerialName("sentiment analysis")
    val sentimentAnalysis: SentimentAnalysis,
    val summary: String,
    @SerialName("tone analysis")
    val toneAnalysis: ToneAnalysis,
)
@Serializable
data class EmotionAnalysis(
    @SerialName("emotion_predictions")
    val emotionPredictions: List<EmotionPrediction>,
    @SerialName("producer_id")
    val producerId: ProducerId,
)
@Serializable

data class EmotionPrediction(
    val emotion: Emotion,
    @SerialName("emotion_mentions")
    val emotionMentions: List<EmotionMention>,
    val target: String,
)
@Serializable

data class Emotion(
    val anger: Double,
    val disgust: Double,
    val fear: Double,
    val joy: Double,
    val sadness: Double,
)
@Serializable

data class EmotionMention(
    val emotion: Emotion2,
    val span: Span,
)
@Serializable

data class Emotion2(
    val anger: Double,
    val disgust: Double,
    val fear: Double,
    val joy: Double,
    val sadness: Double,
)
@Serializable

data class Span(
    val begin: Long,
    val end: Long,
    val text: String,
)
@Serializable

data class ProducerId(
    val name: String,
    val version: String,
)
@Serializable
data class KeywordExtraction(
    @SerialName("producer_id")
    val producerId: ProducerId2,
    val views: List<View>,
)
@Serializable

data class ProducerId2(
    val name: String,
    val version: String,
)
@Serializable

data class View(
    val name: String,
    val properties: List<Property>,
)
@Serializable

data class Property(
    @SerialName("aql_property")
    val aqlProperty: AqlProperty,
)
@Serializable

data class AqlProperty(
    val label: String,
    val match: Match,
)
@Serializable

data class Match(
    val begin: Long,
    val end: Long,
    val text: String,
)
@Serializable
data class SentimentAnalysis(
    @SerialName("document_sentiment")
    val documentSentiment: DocumentSentiment,
    @SerialName("producer_id")
    val producerId: ProducerId3,
    @SerialName("targeted_sentiments")
    val targetedSentiments: TargetedSentiments,
)
@Serializable

data class DocumentSentiment(
    val label: String,
    val mixed: Boolean,
    val score: Double,
    @SerialName("sentiment_mentions")
    val sentimentMentions: List<SentimentMention>,
)
@Serializable

data class SentimentMention(
    val sentimentprob: Sentimentprob,
    val span: Span2,
)
@Serializable

data class Sentimentprob(
    val negative: Double,
    val neutral: Double,
    val positive: Double,
)
@Serializable
data class Span2(
    val begin: Long,
    val end: Long,
    val text: String,
)
@Serializable
data class ProducerId3(
    val name: String,
    val version: String,
)
@Serializable

data class TargetedSentiments(
    @SerialName("producer_id")
    val producerId: ProducerId4,
)
@Serializable

data class ProducerId4(
    val name: String,
    val version: String,
)
@Serializable

data class ToneAnalysis(
    val classes: List<Class>,
    @SerialName("producer_id")
    val producerId: ProducerId5,
)
@Serializable

data class Class(
    @SerialName("class_name")
    val className: String,
    val confidence: Double,
)
@Serializable

data class ProducerId5(
    val name: String,
    val version: String,
)



@Serializable
data class GetSessionKeyword(
    val count: Int = 1,
    val category: String = "",
    val keyword: String = ""
)

@Serializable
data class GetSessionSementics(
    val emotions: List<GetSessionEmotion> = emptyList(),
    val sentiments: List<GetSessionSentiment> = emptyList(),
    val tones: List<GetSessionTone> = emptyList()
)

@Serializable
data class GetSessionEmotion(
    val emoji: String = "",
    val label: String = "",
    val percentage: Int = 0
)

@Serializable
data class GetSessionSentiment(
    val emoji: String = "",
    val label: String = "",
    val percentage: Int = 0
)

@Serializable
data class GetSessionTone(
    val emoji: String? = null,
    val label: String? = null,
    val percentage: Int? = null,
    val source: String? = null
)

@Serializable
data class SessionWidgetMetrics(
    @SerialName("coach_talk_ratio")
    val coachTalkRatio: SessionCoachTalkRatio,

    @SerialName("cognitive_training")
    val cognitiveTraining: SessionCognitiveTraining,

    @SerialName("competitive_environment")
    val competitiveEnvironment: SessionCompetitiveEnvironment,

    @SerialName("development_orientation")
    val developmentOrientation: SessionDevelopmentOrientation,

    @SerialName("game_realism")
    val gameRealism: SessionGameRealism,

    @SerialName("match_analysis")
    val matchAnalysis: SessionMatchAnalysis? = null,

    @SerialName("methodology_consistency")
    val methodologyConsistency: SessionMethodologyConsistency,

    @SerialName("session_intensity")
    val sessionIntensity: SessionSessionIntensity,

    @SerialName("tactical_complexity")
    val tacticalComplexity: SessionTacticalComplexity,

    @SerialName("topic_diversity")
    val topicDiversity: SessionTopicDiversity,
)

@Serializable
data class SessionCoachTalkRatio(
    @SerialName("record_time_ms")
    val recordTimeMs: Long? = null,
    val score: Long = 0,
    val source: String = "",
    @SerialName("speaking_time_sec")
    val speakingTimeSec: Double? = null,
)

@Serializable
data class SessionCognitiveTraining(
    val confidence: String = "",
    val score: Long = 0,
    @SerialName("sub_scores")
    val subScores: SessionCognitiveTrainingSubScores = SessionCognitiveTrainingSubScores(),
)

@Serializable
data class SessionCognitiveTrainingSubScores(
    @SerialName("decision_making")
    val decisionMaking: Long = 0,
    val perception: Long = 0,
    @SerialName("problem_solving")
    val problemSolving: Long = 0,
    val scanning: Long = 0,
    @SerialName("tactical_awareness")
    val tacticalAwareness: Long = 0,
)

@Serializable
data class SessionCompetitiveEnvironment(
    val confidence: String = "",
    val score: Long = 0,
    @SerialName("sub_scores")
    val subScores: SessionCompetitiveEnvironmentSubScores =
        SessionCompetitiveEnvironmentSubScores(),
)

@Serializable
data class SessionCompetitiveEnvironmentSubScores(
    val accountability: Long = 0,
    val competition: Long = 0,
    @SerialName("scoring_systems")
    val scoringSystems: Long = 0,
    @SerialName("time_pressure")
    val timePressure: Long = 0,
    @SerialName("winning_conditions")
    val winningConditions: Long = 0,
)

@Serializable
data class SessionDevelopmentOrientation(
    val confidence: String = "",
    val score: Long = 0,
)

@Serializable
data class SessionGameRealism(
    val confidence: String = "",
    val score: Long = 0,
    @SerialName("sub_scores")
    val subScores: SessionGameRealismSubScores = SessionGameRealismSubScores(),
)

@Serializable
data class SessionGameRealismSubScores(
    @SerialName("decision_making")
    val decisionMaking: Long = 0,
    @SerialName("directional_play")
    val directionalPlay: Long = 0,
    @SerialName("match_pressure")
    val matchPressure: Long = 0,
    val opposition: Long = 0,
    val transitions: Long = 0,
)

@Serializable
data class SessionMatchAnalysis(
    val confidence: String = "",
    @SerialName("root_causes")
    val rootCauses: List<String> = emptyList(),
    val score: Long = 0,
    val strengths: List<String> = emptyList(),
    @SerialName("sub_scores")
    val subScores: SessionMatchAnalysisSubScores = SessionMatchAnalysisSubScores(),
    @SerialName("training_priorities")
    val trainingPriorities: List<SessionTrainingPriority> = emptyList(),
    val weaknesses: List<String> = emptyList(),
)

@Serializable
data class SessionMatchAnalysisSubScores(
    @SerialName("in_possession")
    val inPossession: Long = 0,
    @SerialName("out_of_possession")
    val outOfPossession: Long = 0,
    val transitions: Long = 0,
)

@Serializable
data class SessionTrainingPriority(
    val area: String = "",
    val percentage: Long = 0,
)

@Serializable
data class SessionMethodologyConsistency(
    val confidence: String = "",
    @SerialName("consistent_principles")
    val consistentPrinciples: List<String>? = emptyList(),
    val score: Long = 0,
)

@Serializable
data class SessionSessionIntensity(
    val confidence: String = "",
    val score: Long = 0,
)

@Serializable
data class SessionTacticalComplexity(
    val confidence: String = "",
    val score: Long = 0,
    @SerialName("top_concepts")
    val topConcepts: List<String> = emptyList(),
)

@Serializable
data class SessionTopicDiversity(
    val confidence: String = "",
    val score: Long = 0,
    @SerialName("topics_covered")
    val topicsCovered: List<SessionTopicCovered> = emptyList(),
)

@Serializable
data class SessionTopicCovered(
    val topic: String = "",
    val percentage: Long = 0,
)